import styled from '@emotion/styled';

const Container = styled.div`
  background-color: #dbddf5;
  color: #060b6e;
  display: inline-block;
  font-size: 15px;
  line-height: 16px;
  padding: 12px 16px;
  position: relative;
  width: 100%;
`;

const InfoMessage = ({ message }) => (
  <Container>
    <strong>Info Message:</strong> {message}
  </Container>
);

export default InfoMessage;
